import React from 'react';
import { Trans } from 'react-i18next';
import { TFunction } from 'i18next';
import { Hyperlink } from '../../atoms/Hyperlink';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Namespace } from '../../../translation/namespace';
import IUrl from '../../../types/IUrl';
import { IFrame, IFrameContainer } from '../../../_lib/components/IFrame';

// special iframes that need more height to be displayed correctly.
// this is only a quick workaround, if we want to continue using iframes we need to be able to configure height
const isSpecialIframe = (url?: string) =>
  url?.includes('cocoon/portal/res') && url.includes('t=19') && url.includes('hra=');

const getHostnameFromUrl = (url?: string): string | undefined => {
  if (!url) {
    return url;
  }
  try {
    return new URL(url).hostname;
  } catch {
    return url;
  }
};

type On2IFrameProps = {
  blockedDueToAnonymousAccess: boolean;
  iframe?: IUrl;
  loginUrl?: IUrl;
};

export default function On2IFrame({ blockedDueToAnonymousAccess, iframe, loginUrl }: On2IFrameProps) {
  const { t } = useSonTranslation('On2IFrame');

  if (blockedDueToAnonymousAccess && loginUrl && !iframe) {
    const message = (
      <Trans
        i18nKey={`${Namespace.On2IFrame}:explanationAnonymousAccess`}
        t={t as TFunction}
        components={[
          <Hyperlink key={loginUrl.url} to={loginUrl.url} routing={false} className="interaction-status__link" />,
        ]}
      />
    );

    return (
      <div className="on2-iframe">
        <StatusInfoError message={message} />
      </div>
    );
  }

  const height: '1000px' | '100vh' = isSpecialIframe(iframe?.url) ? '1000px' : '100vh';

  return (
    <IFrameContainer style={{ height }}>
      <IFrame
        title={t('externalApplicationOfUrl', { url: getHostnameFromUrl(iframe?.url) as string })}
        src={iframe?.url as string}
      />
    </IFrameContainer>
  );
}
